import bindStorage from 'nuxt-vuex-localstorage/plugins/bindStorage'

export default (ctx) => {
  const options = {"localStorage":["site","user","organization"],"sessionStorage":["api","users"]}
  bindStorage(ctx, options)
}
